<template>
  <div
    class="qna-session animate__slideInUp animate__animated animate__faster vertical layout"
    id="qna-session-box"
  >
    <div class="text-right close-icon" @click="closeRequest()">
      {{ $t("closeAvatar") }}
      <i class="fas fa-times" />
    </div>
    <div class="audience-cta">
      <form name="get-presentation" @submit.prevent="getPresentation()">
        <h4 v-if="presentation.enableAudienceRequestPresentation">
          Get the slides
        </h4>
        <h4 v-if="!presentation.enableAudienceRequestPresentation">
          Request the slides
        </h4>
        <input
          type="email"
          placeholder="Enter email"
          v-model="email"
          required
          :disabled="loading || isDone"
        >
        <ui-button
          block
          size="sm"
          type="submit"
          :class="{'btn-request-disable': !email || isDone || loading}"
          :disabled="!email || isDone || loading"
          class="round"
        >
          <template v-if="presentation.enableAudienceRequestPresentation">
            <template v-if="!isDone">
              Send
              <Spinner class="ml-2" v-if="loading" />
            </template>
            <template v-if="isDone">
              Sent <i class="fas fa-check ml-2" />
            </template>
          </template>
          <template v-if="!presentation.enableAudienceRequestPresentation">
            <template v-if="!isDone">
              Request
              <Spinner class="ml-2" v-if="loading" />
            </template>
            <template v-if="isDone">
              Requested <i class="fas fa-check ml-2" />
            </template>
          </template>
        </ui-button>

        <p v-if="isDone && presentation.enableAudienceRequestPresentation" class="font-sm">
          The slides will be sent to your email shortly.
        </p>
        <p v-if="isDone && !presentation.enableAudienceRequestPresentation" class="font-sm">
          If the presenter approves, you will get an email.
        </p>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/util'
import UiButton from '@/components/UI/Button'
import Config from '@/config'
import Spinner from '@/components/UI/Spinner'

export default {
  components: {
    UiButton,
    Spinner,
  },
  data() {
    return {
      showForm: false,
      email: '',
      loading: false,
      isDone: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      audienceEmail: (state) => state.audienceEmail,
      audienceId: (state) => state.audienceId,
      slide: (state) => state.slide,
    }),
  },
  mounted() {
    this.email = this.audienceEmail
  },
  methods: {
    closeRequest() {
      this.$store.state.showRequestPresentation = false
      utils.gaTrackEvent('Audience', 'Close request presentation > Click')
    },
    async getPresentation() {
      if (this.loading || !this.email || this.isDone) return
      this.loading = true
      const payload = {
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        audienceId: this.audienceId,
        email: this.email,
      }
      await this.$http.post(Config.api.requestPresentation, payload)
      this.loading = true
      this.isDone = true
      if (this.presentation.enableAudienceRequestPresentation) {
        utils.gaTrackEvent(
          'Audience',
          'Get this presentation > Submitted email',
          this.email,
          '',
        )
      } else {
        utils.gaTrackEvent(
          'Audience',
          'Request this presentation > Submitted email',
          this.email,
          '',
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.round {
  border-radius: 30px;
  &:hover {
    background-color: #257ADC;
  }
}
.qna-session {
  background-color: #fff !important;
  width: 100%;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  max-width: 600px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
  color: #333 !important;
}
.qna-submit-box {
  border-radius: 4px;
  overflow: hidden;

}

.qna-session {
  &.text-white {
    .tab-list-question,
    .item-question {
      border-color: rgba(255, 255, 255, 0.2);
    }
  }
}

.close-icon {
  position: absolute;
  top: -28px;
  right: 0px;
  cursor: pointer;
  padding: 6px 10px 5px;
  z-index: 100;
  color: #fff;
  background-color: #000;
  border-radius: 25px;
  font-size: 10px;
  text-transform: uppercase;
}

.audience-cta-wrapper {
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  text-decoration: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 20;
}

.audience-cta {
  .audience-cta__link {
    color: #257adc;
    font-weight: bold;
    font-size: 16px;
  }

  h4 {
    margin: 0;
    text-align: center;
    margin-bottom: 12px;
  }

  input {
    width: 100%;
    border-radius: 8px;
    border: 1px solid #ddd;
    height: 36px;
    padding: 0 16px;
    font-size: 14px;
    margin-bottom: 12px;
    outline: none;
    &:focus {
      border: 1px solid #257adc;
    }
  }
}
p.font-sm {
  font-size: 12px;
  text-align: center;
}

.btn-request-disable {
  opacity: 0.7;
}
</style>
